import React from 'react';
import AdminModalContent, { AdminModalContentProps } from './AdminModalContent';
import TrueImpactModal, {
  modalHeightAutoStyles,
  modelExtraRadiusStyles,
} from 'shared/design-system/components/TrueImpactModal';

interface AdminModalProps extends AdminModalContentProps {
  open: boolean;
  handleClose: () => unknown;
}

const AdminModal: React.FC<AdminModalProps> = ({
  open,
  report,
  handleClose,
}) => {
  return (
    <TrueImpactModal
      maxWidth="800px"
      open={open}
      onClose={handleClose}
      hideFooter={true}
      title={`Report: ${report.year}`}
      addStyles={modalHeightAutoStyles + modelExtraRadiusStyles}
    >
      <AdminModalContent report={report} />
    </TrueImpactModal>
  );
};

export default AdminModal;
